import { ICurrentUser, IUser } from "../models/user.model";
import ServiceBase from "./base.service";

export class UsersService extends ServiceBase {
  current = async (): Promise<ICurrentUser> => await this.get<ICurrentUser>("users/current");

  search = async (query: string): Promise<IUser[]> => this.get<IUser[]>(`users/search?query=${query}&top=5`);

  departmentChiefs = async (departments: string[]): Promise<IUser[]> =>
    this.get<IUser[]>(`users/department-chiefs?departments=${departments.join(",")}`);

  divisionChiefs = async (divisions: string[]): Promise<IUser[]> =>
    this.get<IUser[]>(`users/division-chiefs?divisions=${divisions.join(",")}`);
}

const userService = new UsersService();

export default userService;
